import { GroupType } from '../model/chatGroup';
import { UserListResponse } from './commonResponse';
import { post } from './request';

const baseUrl = process.env.REACT_APP_COCALERO_API_URL + `/v2/web/chat_groups`;

export type ChatGroupListResponse = {
    id: number;
    type: GroupType;
    name: string;
    image: string;
    users: UserListResponse[];
};

export const ChatGroupApi = {
    recent: (offset: number, limit: number, types: string[]): Promise<ChatGroupListResponse[]> =>
        post(baseUrl + '/recent', {
            chat_group: {
                offset: offset,
                limit: limit,
                type: types,
            },
        }).then((res: { chat_groups: ChatGroupListResponse[] }) => res.chat_groups),
};
